export enum HttpMethodsEnum {
  POST = "post",
  GET = "get",
  PUT = "put",
  DELETE = "delete",
}

export enum PermissionsEnum {
  DOCTOR = "DOCTOR",
  PATIENT = "PATIENT",
  CARE_GIVER = "CARE_GIVER",
}

export enum VitalsEnum {
  LIFE_STYLE = "Lifestyle",
  PRESCRIPTION = "Prescription",
  VITALS = "Vitals",
}

export enum VitalsStatusEnum {
  GOOD = "GOOD",
  WARNING = "WARNING",
  DANGER = "DANGER",
}

export enum PlanStatusEnum {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum NotificationEnum {
  CREATE_PLAN = "CREATE_PLAN",
  EDIT_PLAN = "EDIT_PLAN",
  ACTIVATE_PLAN = "ACTIVATE_PLAN",
  REJECT_PLAN = "REJECT_PLAN",
  VITALS_WARNING = "VITALS_WARNING",
  MEDICATION_REMINDER = "MEDICATION_REMINDER",
}
